/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import {FeatureFlaggingService} from '../services/feature-flagging.service';

@Directive({
  selector: '[appHasFeatureFlag]',
  standalone: false,
})
export class FeatureFlagDirective {
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly featureFlaggingService = inject(FeatureFlaggingService);

  @Input() set appHasFeatureFlag(flag: string) {
    this.isFeatureEnabled(flag).then((hasView) => {
      if (hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }

  async isFeatureEnabled(flag: string): Promise<boolean> {
    const featureFlag = await this.featureFlaggingService.load();
    return !!featureFlag?.grantedApps?.includes(flag);
  }
}
